module.exports = __webpack_public_path__ + "static/2ndFloor-Desktop-10-27-07308e65c5d47a0e0e2e8952633cd772.jpg";